import React from 'react';
import { TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { split as _split } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';

import styles from './TermsAndConditionsText.Styles';

const TermsAndConditionsText = ({
  localizeKey,
  hyperlinksKeys,
  onTermsAndConditionsPress,
  onReturnPolicyPress,
  termsAndConditionsStyle,
}) => {
  const placeholderPattern = '%1$s';
  const translatedKey = ContentManager.translate(localizeKey, [
    placeholderPattern,
    placeholderPattern,
  ]);
  const TermsAndConditionsTextSplitted = _split(translatedKey, placeholderPattern);
  return (
    <VFText type={'primary'} style={styles.termsText}>
      <VFText localize={false} i18nKey={TermsAndConditionsTextSplitted[0]} />

      <TouchableWithoutFeedback onPress={onReturnPolicyPress}>
        <VFText
          i18nKey={hyperlinksKeys[0]}
          style={[styles.hyperLinkText, termsAndConditionsStyle]}
        />
      </TouchableWithoutFeedback>

      <VFText localize={false} i18nKey={TermsAndConditionsTextSplitted[1]} />

      <TouchableWithoutFeedback onPress={onTermsAndConditionsPress}>
        <VFText
          i18nKey={hyperlinksKeys[1]}
          style={[styles.hyperLinkText, termsAndConditionsStyle]}
        />
      </TouchableWithoutFeedback>
      <VFText localize={false} i18nKey={TermsAndConditionsTextSplitted[2]} />
    </VFText>
  );
};
TermsAndConditionsText.propTypes = {
  hyperlinksKeys: PropTypes.arrayOf(PropTypes.string),
  localizeKey: PropTypes.string,
  onTermsAndConditionsPress: PropTypes.func,
  onReturnPolicyPress: PropTypes.func,
  termsAndConditionsStyle: ViewPropTypes.style,
};
TermsAndConditionsText.defaultProps = {
  hyperlinksKeys: [],
};
export default TermsAndConditionsText;
